import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Checkbox from '@material-ui/core/Checkbox';
import { useDispatch } from 'react-redux';
import * as orgActions from '../../../redux/organisations';
import styled from 'styled-components';

export default function CreateCharge({ orgId }) {
  const [open, setOpen] = useState(false);
  const [checked, setChecked] = useState(false);
  const [selectValue, setSelectValue] = useState('0.00');
  
  const dispatch = useDispatch();

  const handleClickOpen = () => setOpen(true);

  const handleClose = () => {
    setOpen(false);
    setSelectValue('0.00');
    setChecked(false);
  };

  const handleSubmit = () => {
    dispatch(orgActions.createCharge(orgId, { amount: parseFloat(selectValue) }));
    setOpen(false);
    setSelectValue('0.00');
    setChecked(false);
  };

  const handleChange = event => {
    setSelectValue(event.target.value);
    setChecked(event.target.checked);
  };

  const handleCheckboxChange = event => {
    if (selectValue <= 0) return setChecked(false);
    setChecked(event.target.checked);
  };

  return (
    <div>
      <ChargeButton onClick={handleClickOpen}>
        Create Charge
      </ChargeButton>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Create a one-off charge on Stripe</DialogTitle>
        <DialogContent>
          <Input
            error={selectValue <= 0}
            type='number'
            value={selectValue}
            inputProps={{ min: '0.00', step: '0.01' }}
            startAdornment={<InputAdornment position='start'>£</InputAdornment>}
            onChange={handleChange}
          />
          <Checkbox
            checked={checked}
            onChange={handleCheckboxChange}
            inputProps={{ 'aria-label': 'controlled' }}
          />Select checkbox to submit
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button disabled={!checked} onClick={handleSubmit}>Submit</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

const ChargeButton = styled(Button)` &&
{
  color: white;
  background-color: #2f9d6d;
  border: none;
  text-transform: capitalize;
  border-radius: 8px;
  font-weight: bold;
  font-size: 14px;
  height: 30px;
  :hover {
    background-color: #50B181;
  }
}`;
